module.exports = __webpack_public_path__ + "img/femme.e129427d.png";